import { useLanguage } from "../context/LanguageContext";

function LanguageToggle({ variant = "dark" }) {
  const { lang, setLang } = useLanguage();
  const isGold = variant === "gold";
  const isDark = variant === "dark";
  const idle = isGold
    ? "text-white/80 hover:bg-white/10"
    : isDark
      ? "text-white/90 hover:bg-white/10"
      : "text-slate-600 hover:bg-slate-100";
  const active = isGold
    ? "bg-[#c9a46a] text-[#1a1408]"
    : isDark
      ? "bg-white text-slate-900"
      : "bg-slate-900 text-white";
  const border = isGold ? "border-[#c9a46a]/70" : isDark ? "border-white/30" : "border-slate-300";

  return (
    <div className={`inline-flex overflow-hidden rounded-full border text-xs font-medium ${border}`}>
      <button
        type="button"
        className={`px-3 py-1 ${lang === "en" ? active : idle}`}
        onClick={() => setLang("en")}
      >
        EN
      </button>
      <button
        type="button"
        className={`px-3 py-1 ${lang === "cn" ? active : idle}`}
        onClick={() => setLang("cn")}
      >
        中文
      </button>
    </div>
  );
}

export default LanguageToggle;
